import { StepByStepSectionData } from '../../constructSectionsData'
import { NavigationDotsContainer, Dots, Dot } from './styles'

type Props = {
  sections: StepByStepSectionData[]
  currentIndex: number
}

export const NavigationDots = (props: Props) => {
  const { sections, currentIndex } = props

  return (
    <NavigationDotsContainer>
      <Dots>
        {sections?.map((_item, index) => (
          <Dot key={`dot-${index}`} $isActive={index === currentIndex} />
        ))}
      </Dots>
    </NavigationDotsContainer>
  )
}
